"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagneticShield = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class MagneticShield extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MAGNETIC_SHIELD,
            tags: [Tags_1.Tags.SPACE],
            cost: 24,
            tr: { tr: 4 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.ENERGY, 3)),
            metadata: {
                cardNumber: 'X24',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.tr(4).digit),
                description: 'Requires 3 power tags. Raise your TR 4 steps.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.increaseTerraformRatingSteps(4);
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 4 });
    }
}
exports.MagneticShield = MagneticShield;
//# sourceMappingURL=MagneticShield.js.map